module.exports = __webpack_public_path__ + "img/book5.db7a13dd.jpg";